<template>
  <div :ref="grupo" class="combinados-list">
    <combinado-card
      :producto="producto"
      v-for="(producto,i) in productos"
      @update-product="updateCombinados"
      @remove-product="removeFromCombinados"
      :lleva-precio-mitad="llevaPrecioMitad"
      :key="`combinado_${grupo}_${producto.id}_${i}`"
    ></combinado-card>
  </div>
</template>
<script>
import CombinadoCard from '../cards/CombinadoCard.vue'

export default {
  name: 'Combinados',
  components: { CombinadoCard },
  props: {
    grupo: {
      type: String
    },
    productos: {
      type: Array
    },
    cantidadMinima: {
      type: Number
    },
    cantidadMaxima: {
      type: Number
    },
    llevaCantidad: {
      type: Boolean
    },
    llevaImporte: {
      type: [Boolean, String, Number],
      default: false
    },
    llevaPrecioMitad: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      combinados: [],
      cantidadTotal: 0,
      precioFinal: 0
    }
  },
  methods: {
    esLlevaImporte () {
      const v = this.llevaImporte
      return v === true || v === 1 || v === '1' || (typeof v === 'string' && v.toLowerCase() === 'true')
    },
    importeDe (combinado) {
      const precio = Number(combinado.PrecioUnitario) || 0
      const cant = Number(combinado.cant) || 1
      return precio * cant
    },
    updateCombinados (combinado) {
      const existing = this.combinados.find(e => e.id === combinado.id)
      if (existing && this.esLlevaImporte()) {
        this.$emit('restarImporte', this.importeDe(existing))
      }
      if (existing) {
        this.combinados = this.combinados.filter(e => e.id !== combinado.id)
      }
      const item = {
        id: combinado.id,
        name: combinado.nombre,
        cant: combinado.cant,
        grupo: combinado.GuidGrupo,
        PrecioUnitario: combinado.PrecioUnitario
      }
      this.combinados.push(item)
      this.cantidadTotal = this.combinados.reduce((a, b) => a + b.cant, 0)
      if (this.esLlevaImporte()) this.$emit('sumarImporte', this.importeDe(item))
    },
    removeFromCombinados (combinadoToRemove) {
      const existing = this.combinados.find(e => e.id === combinadoToRemove.id)
      if (existing && this.esLlevaImporte()) {
        this.$emit('restarImporte', this.importeDe(existing))
      }
      if (existing) {
        this.combinados = this.combinados.filter(e => e.id !== combinadoToRemove.id)
      }
      this.cantidadTotal = this.combinados.reduce((a, b) => a + b.cant, 0)
    }
  },
  watch: {
    combinados (newValue) {
      const payload = {
        grupo: this.grupo,
        items: newValue
      }
      this.$emit('updateCustomItem', payload)
    }
  }
}
</script>
<style scoped>
.combinados-list {
  margin: 0 -4px;
}
</style>
